module.exports = __webpack_public_path__ + "static/media/LK_logo.e19cc453.svg";